import { useChangingTheme } from '@/features'
import { tenantConfig } from '../config/tenant'

const Logo = ({
    dark,
    width,
    style,
}: {
    dark?: boolean
    width?: number
    style?: any
}) => {
    const { isDark } = useChangingTheme()

    const logoUrl =
        dark ?? !isDark
            ? tenantConfig.logo?.dark_url
            : tenantConfig.logo?.light_url

    if (!logoUrl) {
        return <div style={{ width: width ?? 110, height: 32 }} />
    }

    return (
        <img
            src={logoUrl}
            height={32}
            alt="logo"
            style={
                style
                    ? style
                    : {
                          objectFit: 'contain',
                          maxWidth: 'calc(100% - 32px)',
                          height: `64px`,
                      }
            }
        />
    )
}

export default Logo
